import { render, staticRenderFns } from "./VoyceTableWithoutCard.vue?vue&type=template&id=4b4e1bf9&"
import script from "./VoyceTableWithoutCard.vue?vue&type=script&lang=js&"
export * from "./VoyceTableWithoutCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports